import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8 } from "styled-components";
import { hasItems, takeFirst } from "~/features/app/utils";
import { Link } from "~/features/ui/link";
import { Button } from "~/features/ui/button";
import { Headline } from "~/features/ui/headline";
import { isLinkValid } from "~/features/ui/link/utils";
import { Asset, type Props as AssetProps } from "~/features/craft/asset";
import ArrowRight from "~/public/icons/arrow-right.svg";
import ArrowTopRight from "~/public/icons/arrow-top-right.svg";
const layoutStyles = {
  horizontal: {
    "@media (min-width: 1024px)": {
      "flexDirection": "row",
      "alignItems": "center"
    }
  },
  vertical: {
    "@media (min-width: 1024px)": {
      "flexDirection": "column"
    }
  }
} as const;
type PlainLink = Record<string, unknown> & {
  href?: string;
  newWindow?: boolean;
  text?: React.ReactNode;
};
type PlainAsset = Record<string, unknown>;
function getPlainLinkIcon(link?: PlainLink | null) {
  if (!link) {
    return undefined;
  }
  return link.newWindow ? ArrowTopRight : ArrowRight;
}
export type CallToActionListItemViewProps = {
  headline?: string | null;
  image?: PlainAsset | Array<PlainAsset | null | undefined> | null;
  layout: keyof typeof layoutStyles;
  link?: PlainLink | Array<PlainLink | null | undefined> | null;
  showLinks: boolean;
  text?: React.ReactNode;
};
export function CallToActionListItemView({
  headline,
  image,
  layout,
  link,
  showLinks,
  text
}: CallToActionListItemViewProps) {
  const cta = takeFirst(link);
  const icon = getPlainLinkIcon(cta);
  return <_StyledDiv $_css={[{
    "display": "flex",
    "height": "100%",
    "width": "100%",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "justifyContent": "space-between",
    "gap": "var(--spacing-sm)",
    "rowGap": "var(--spacing-xl)",
    "padding": "var(--spacing-lg)",
    "@media (min-width: 1024px)": {
      "padding": "var(--spacing-xl)"
    }
  }, layoutStyles[layout]]}>
      <_StyledDiv2>
        <_StyledDiv3>
          <_StyledDiv4 $_css2={[{
          "display": "flex",
          "flex": "1 1 0%",
          "flexDirection": "column",
          "gap": "var(--spacing-lg)",
          "@media (min-width: 1024px)": {
            "gap": "var(--spacing-md)"
          }
        }, !isLinkValid(cta) && {
          "justifyContent": "space-between"
        }]}>
            {headline && <_StyledHeadline type="h2" text={headline} />}
            {text && <_StyledP>{text}</_StyledP>}
          </_StyledDiv4>

          {isLinkValid(cta) && <_StyledDiv5>
              <Button as={Link} {...cta} icon={icon} variant={showLinks ? "underline" : "secondary"} />
            </_StyledDiv5>}
        </_StyledDiv3>
        {hasItems(takeFirst(image)) && <_StyledAsset asset={takeFirst(image) as AssetProps["asset"]} />}
      </_StyledDiv2>
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-1ojv4kj-0"
})`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div").withConfig({
  componentId: "sc-sf-1ojv4kj-1"
})({
  "display": "flex",
  "width": "100%",
  "flex": "1 1 0%",
  "justifyContent": "space-between",
  "columnGap": "var(--spacing-md)"
});
var _StyledDiv3 = _styled3("div").withConfig({
  componentId: "sc-sf-1ojv4kj-2"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "gap": "var(--spacing-lg)",
  "@media (min-width: 1024px)": {
    "gap": "var(--spacing-xl)"
  }
});
var _StyledDiv4 = _styled4("div").withConfig({
  componentId: "sc-sf-1ojv4kj-3"
})`${p => p.$_css2}`;
var _StyledHeadline = _styled5(Headline).withConfig({
  componentId: "sc-sf-1ojv4kj-4"
})({
  "fontSize": "2.2rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "3.2rem",
    "lineHeight": "1.2",
    "letterSpacing": "0.032rem",
    "fontWeight": "400"
  }
});
var _StyledP = _styled6("p").withConfig({
  componentId: "sc-sf-1ojv4kj-5"
})({
  "fontSize": "1.6rem",
  "lineHeight": "1.5",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "1.8rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.018rem",
    "fontWeight": "400"
  }
});
var _StyledDiv5 = _styled7("div").withConfig({
  componentId: "sc-sf-1ojv4kj-6"
})({
  "marginTop": "auto"
});
var _StyledAsset = /*#__PURE__*/_styled8(Asset).withConfig({
  displayName: "call-to-action-list-item___StyledAsset",
  componentId: "sc-mksd1n-0"
})({
  "maxWidth": "100px",
  "@media (min-width: 1024px)": {
    "maxWidth": "150px"
  }
});